/** Formátovací helpery fronty plateb (fáze 3). */

// Haléře zobrazit jen když existují (přijatá částka je může mít, F3-B).
const czkNumber = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 2 })

/** Částka v CZK pro fronty — např. „1 000 000 Kč". */
export function formatCzk(amount: number): string {
  return `${czkNumber.format(amount)} Kč`
}

/** Seskupené číslo bez měny — předvyplnění inputu (parser částky mezery zvládne). */
export function formatAmountInput(amount: number): string {
  return czkNumber.format(amount)
}

/** Datum a čas ve tvaru dd.MM.yyyy HH:mm (cs-CZ). */
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('cs-CZ', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
